import Card from './Card';

const Product = ({ product, index, ...res }) => {
    return product.plans.length > 0 ? (
        <Card
            product={product}
            data={product.plans[index]}
            key={index}
            monthly={index === 0}
            {...res}
        />
    ) : null;
};

export default Product;
